import { render, staticRenderFns } from "./Collaborations.vue?vue&type=template&id=78366837&scoped=true"
import script from "./Collaborations.vue?vue&type=script&lang=js"
export * from "./Collaborations.vue?vue&type=script&lang=js"
import style0 from "./Collaborations.vue?vue&type=style&index=0&id=78366837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78366837",
  null
  
)

export default component.exports